import angular from 'angular';
import 'angular-ui-router';
import 'angular-validation-match';

import tnBillingDirectiveNewCreditCard from './billing-directive-new-credit-card.directive/billingDirectiveNewCreditCard';
import BillingDirectiveSavedCreditCards from './billing-directive-saved-credit-cards.directive/billingDirectiveSavedCreditCards';
import BillingInfo from './billing.controller/billing';
import ccvalidator from './cc-validator.directive/ccValidator';
import tnFieldGroupAddress from './field-group-address.directive/fieldGroupAddress';
import BillingService from './service.tn.billing';

export default angular
    .module('tn.billing', [
        'validation.match',
        'ui.router',
        'tn.user',
        'tn.cart',
        'tn.stripe',
        'tn.ui',
    ])
    // components
    .controller('tn.billing.controller.billingInfo', BillingInfo)
    .directive('ccvalidator', ccvalidator)
    .directive(
        'tnBillingDirectiveNewCreditCard',
        tnBillingDirectiveNewCreditCard
    )
    .directive(
        'tnBillingDirectiveSavedCreditCards',
        BillingDirectiveSavedCreditCards
    )
    .directive('tnFieldGroupAddress', tnFieldGroupAddress)
    // providers
    .service('tn.billing.service', BillingService).name;
